import { Tr, Td, Text, useDisclosure } from "@chakra-ui/react";
import OrderModal from "./OrderModal";

const OrderTableRow = ({ order, index }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Tr>
      <Td fontSize={{base:"10px",md:"12px",tablet:"16px"}}>{index + 1}</Td>
      <Td fontSize={{base:"10px",md:"12px",tablet:"16px"}}>{order?.id}</Td>
      <Td fontSize={{base:"10px",md:"12px",tablet:"16px"}}>
        <Text
          cursor={"pointer"}
          color={"scarlet"}
          textDecor={"underline"}
          onClick={onOpen}
        >
          View Details
        </Text>
      </Td>
      <OrderModal orderId={order?.id} isOpen={isOpen} onClose={onClose} />
    </Tr>
  );
};

export default OrderTableRow;
